/**
 *
 * @module commerceClientEndpoint
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef CommerceClientEndpoint
 * @type {Object}
 *
 * @property {String} guid
 * @property {String} priceOrder
 * @property {String} zipCode
 * @property {String} submitOrder
 * @property {String} submitOrderWithPaymentMethod
 * @property {String} orderStatus
 * @property {String} createPaymentMethod
 * @property {String} getDefaultPaymentMethod
 * @property {String} getPaymentCard
 * @property {String} createPaymentMethodEast
 * @property {String} createPaymentMethodWest
 *
 */

/**
 *
 * @enum
 * @type {CommerceClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    generateGuid: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    priceOrder: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    lookupByZipCode: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    submitOrder: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    submitOrderWithPaymentMethod: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getOrderStatus: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createPaymentMethod: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getDefaultPaymentMethod: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getPaymentCard: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createPaymentMethodEast: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createPaymentMethodWest: null
});



// WEBPACK FOOTER //
// ./src/services/commerce/commerceClientEndpoint.js